<script setup>
import { cookieRef } from '@/@layouts/stores/config'
import DueTab from '@/views/quality/audit-collection/DueTab.vue'
import UpcomingTab from '@/views/quality/audit-collection/UpcomingTab.vue'
import AdhocTab from '@/views/quality/audit-collection/AdhocTab.vue'

definePage({
  meta: {
    name: 'incident-audit-schedule',
    subject: 'quality.menu',
    action: 'audit_collection',
  },
})

const currentTab = ref('adhoc')

const tabOptions = [
  { title: 'Ad-hoc', value: 'adhoc' },
  { title: 'Due', value: 'due' },
  { title: 'Upcoming', value: 'upcoming' },
]

const search = ref('')
const debouncedSearch = refDebounced(search, 500)

const typeOptions = await getEnumValue('AuditType', true)
const selectedType = ref(null)

const selectedUnit = cookieRef('selectedUnit')

const activeTabRef = ref(null)

const refreshTab = () => {
  activeTabRef.value?.fetchAudits?.()
  activeTabRef.value?.fetchCollections?.()
}
</script>

<template>
  <section>
    <VCard
      variant="flat"
      class="border"
    >
      <VCardText class="d-flex flex-wrap py-4 gap-4">
        <!-- Desktop: Button Toggle -->
        <VBtnToggle
          v-model="currentTab"
          mandatory
          color="primary"
          variant="tonal"
          density="compact"
          class="d-none d-md-flex"
        >
          <VBtn
            v-for="opt in tabOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.title }}
          </VBtn>
        </VBtnToggle>

        <!-- Mobile: Dropdown -->
        <div class="d-md-none flex-grow-1">
          <AppSelect
            v-model="currentTab"
            :items="tabOptions"
            item-title="title"
            item-value="value"
            density="compact"
            placeholder="Status"
          />
        </div>

        <VSpacer class="d-none d-md-block" />

        <div class="d-flex align-center gap-4 flex-grow-1 flex-md-grow-0">
          <div
            class="flex-grow-1 flex-md-grow-0"
            style="min-inline-size: 11rem;"
          >
            <AppSelect
              v-model="selectedType"
              :items="typeOptions"
              :item-title="item => item.title"
              :item-value="item => item.value"
              placeholder="Audit Type"
              density="compact"
              clearable
            />
          </div>

          <div
            class="flex-grow-1 flex-md-grow-0"
            style="min-inline-size: 10rem;"
          >
            <AppTextField
              v-model="search"
              placeholder="Search"
              density="compact"
            />
          </div>

          <IconBtn
            variant="tonal"
            class="rounded"
            @click="refreshTab"
          >
            <VIcon icon="tabler-refresh" />
          </IconBtn>
        </div>
      </VCardText>

      <VDivider />

      <AdhocTab
        v-if="currentTab === 'adhoc'"
        ref="activeTabRef"
        :search="debouncedSearch"
        :unit-id="selectedUnit"
        :audit-type="selectedType"
      />
      <DueTab
        v-else-if="currentTab === 'due'"
        ref="activeTabRef"
        :search="debouncedSearch"
        :unit-id="selectedUnit"
        :audit-type="selectedType"
      />
      <UpcomingTab
        v-else-if="currentTab === 'upcoming'"
        ref="activeTabRef"
        :search="debouncedSearch"
        :unit-id="selectedUnit"
        :audit-type="selectedType"
      />
    </VCard>
  </section>
</template>

<style>
.v-data-table-footer {
  border-block-start: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
  margin-block-start: 0 !important;
  padding-block: 0.5rem;
}
</style>
